import React, { useCallback, useMemo } from 'react';
import { connect } from 'react-redux';
import { CARD_TYPE } from '../../../../../../../../common/constants/packageConstants';
import { getPackageCardDataL3 } from '../../../../../../../../common/helper/packageDataHelper';
import './styles.scss';

const HandPickedPackages = ({ seoMetaData = {}, seoFilters = {}, packageDetails = [] }) => {
  const { h_1_header = '' } = seoMetaData;

  const getH2Header = useCallback(() => {
    const { themes, dest, depCity, campaign } = seoFilters;
    const keyword = '';

    return `Popular ${dest ? `${dest} ` : ''}${keyword}${
      themes || campaign ? themes || campaign : ''
    } Packages ${depCity ? `From ${depCity}` : ''} ${
      h_1_header ? (h_1_header.includes('Nights') ? `for ${h_1_header.split(dest)[0]}` : '') : ''
    }`;
  }, [seoFilters]);

  const detailList = useMemo(() => {
    const detail = [];
    for (let i = 0; i < packageDetails.length; i++) {
      const packageInfo = packageDetails[i];
      const { cardType = CARD_TYPE.PACKAGE } = packageInfo;
      if (cardType === CARD_TYPE.PACKAGE) {
        const {
          price = '',
          name = '',
          url = '',
          included,
        } = getPackageCardDataL3(packageInfo, seoFilters);
        const { noOfNights = 0 } = packageInfo;

        detail.push({ name, nights: noOfNights, price, url, included });

        if (detail.length >= 10) {
          break;
        }
      }
    }
    return detail;
  }, [packageDetails, seoFilters]);

  const h2Header = useMemo(getH2Header, [getH2Header]);

  return (
    <div className="handPickedPackages">
      <h2 className="h2Header">{h2Header}</h2>
      <table cellPadding={0} cellSpacing={0} width={'100%'} border={1}>
        <thead>
          <tr>
            <th width="450">{h_1_header}</th>
            <th width="120">Day/Night</th>
            <th>Price</th>
          </tr>
        </thead>
        <tbody>
          {detailList?.map(({ name, nights, price, url }) => (
            <tr key={name}>
              <td itemProp="name">
                <a href={url} target="_blank" rel="noreferrer">
                  {name}
                </a>
              </td>
              <td itemProp="partOfTrip">
                {nights + 1} Days/{nights} Nights
              </td>
              <td itemProp="offers" itemScope itemType="https://schema.org/Offer">
                <span itemProp="price">{price}</span>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

const mapStateToProps = ({ seo, listingPackages }) => ({
  seoMetaData: seo.metaData,
  seoFilters: seo.filters,
  packageDetails:
    listingPackages?.packagesByGroupId?.[Object.keys(listingPackages?.packagesByGroupId)?.[0]]
      ?.packages,
});

export default connect(mapStateToProps, null)(HandPickedPackages);
